import {ConditionId, UserId} from '@legit-health/ui';
import {DomainEvent} from '@/shared/contexts/EventDispatcherContext';

export const REQUEST_PHOTO_FOR_CONDITION_ENCOUNTER_CREATED_EVENT =
  'practitioner.request_photo_for_condition_encounter_created_event';

export interface RequestPhotoForConditionEncounterCreatedEvent extends DomainEvent {
  name: string;
  patientId: UserId;
  practitionerId: UserId;
  condition: ConditionId;
  hasPhotoRequested: boolean;
}

export default function createRequestPhotoForConditionEncounterCreatedEvent(
  patientId: UserId,
  practitionerId: UserId,
  condition: ConditionId,
  hasPhotoRequested: boolean
): RequestPhotoForConditionEncounterCreatedEvent {
  return Object.freeze({
    name: REQUEST_PHOTO_FOR_CONDITION_ENCOUNTER_CREATED_EVENT,
    patientId,
    practitionerId,
    condition,
    hasPhotoRequested
  });
}
